import { useState, useEffect } from 'react';
import Cursor from './components/Cursor';
import Loader from './components/Loader';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Membership from './pages/Membership';
import Trainers from './pages/Trainers';
import Contact from './pages/Contact';

const PAGES = { Home, About, Services, Membership, Trainers, Contact };

export default function App() {
  const [page, setPage] = useState('Home');
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 2000);
    return () => clearTimeout(timer);
  }, []);

  const PageComponent = PAGES[page];

  return (
    <>
      <Loader done={loaded} />
      <Cursor />
      <Navbar page={page} setPage={setPage} />
      <main>
        <PageComponent setPage={setPage} />
      </main>
      <Footer setPage={setPage} />
    </>
  );
}
